/**
 * @GENERATED from Figma node 3608:51034
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const EdgeDark = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id5})`}
        d="M20.05 16.884q-.4.21-.823.368a8 8 0 0 1-2.804.505c-3.697 0-6.917-2.543-6.917-5.806a2.46 2.46 0 0 1 1.284-2.133c-3.344.14-4.203 3.625-4.203 5.666 0 5.77 5.319 6.356 6.465 6.356.618 0 1.55-.18 2.109-.356l.102-.035a10.03 10.03 0 0 0 5.203-4.124.313.313 0 0 0-.416-.44"
      />
      <path
        fill={`url(#${_id})`}
        d="M20.05 16.884q-.4.21-.823.368a8 8 0 0 1-2.804.505c-3.697 0-6.917-2.543-6.917-5.806a2.46 2.46 0 0 1 1.284-2.133c-3.344.14-4.203 3.625-4.203 5.666 0 5.77 5.319 6.356 6.465 6.356.618 0 1.55-.18 2.109-.356l.102-.035a10.03 10.03 0 0 0 5.203-4.124.313.313 0 0 0-.416-.44"
        opacity={0.35}
      />
      <path
        fill={`url(#${_id6})`}
        d="M10.26 20.859c-.698-.433-1.301-1-1.777-1.667a6.306 6.306 0 0 1 2.307-9.374c.243-.115.66-.323 1.214-.313a2.53 2.53 0 0 1 2.006 1.016c.316.421.49.931.497 1.457 0-.016 1.91-6.217-6.25-6.217-3.428 0-6.248 3.254-6.248 6.109-.014 1.51.31 3.005.946 4.374a10 10 0 0 0 12.215 5.243 5.9 5.9 0 0 1-4.904-.625z"
      />
      <path
        fill={`url(#${_id2})`}
        d="M10.26 20.859c-.698-.433-1.301-1-1.777-1.667a6.306 6.306 0 0 1 2.307-9.374c.243-.115.66-.323 1.214-.313a2.53 2.53 0 0 1 2.006 1.016c.316.421.49.931.497 1.457 0-.016 1.91-6.217-6.25-6.217-3.428 0-6.248 3.254-6.248 6.109-.014 1.51.31 3.005.946 4.374a10 10 0 0 0 12.215 5.243 5.9 5.9 0 0 1-4.904-.625z"
        opacity={0.41}
      />
      <path
        fill={`url(#${_id3})`}
        d="M13.9 13.628c-.064.082-.258.196-.258.442 0 .204.133.4.368.565 1.124.781 3.241.678 3.247.678a4.65 4.65 0 0 0 2.364-.652A4.8 4.8 0 0 0 22 10.531c.02-1.751-.625-2.915-.886-3.43C19.457 3.861 15.884 2 11.999 2A10 10 0 0 0 2 11.858c.038-2.854 2.875-5.16 6.25-5.16.273 0 1.832.027 3.28.787 1.277.67 1.945 1.48 2.41 2.282.483.834.569 1.887.569 2.306s-.214 1.041-.61 1.555"
      />
      <path
        fill={`url(#${_id4})`}
        d="M13.9 13.628c-.064.082-.258.196-.258.442 0 .204.133.4.368.565 1.124.781 3.241.678 3.247.678a4.65 4.65 0 0 0 2.364-.652A4.8 4.8 0 0 0 22 10.531c.02-1.751-.625-2.915-.886-3.43C19.457 3.861 15.884 2 11.999 2A10 10 0 0 0 2 11.858c.038-2.854 2.875-5.16 6.25-5.16.273 0 1.832.027 3.28.787 1.277.67 1.945 1.48 2.41 2.282.483.834.569 1.887.569 2.306s-.214 1.041-.61 1.555"
      />
      <defs>
        <radialGradient
          id={_id}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(7.45072 0 0 7.07818 14.281 15.94)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.72} stopOpacity={0} />
          <stop offset={0.95} stopOpacity={0.53} />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id={_id2}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-81.384 13.96 4.403)scale(11.2039 9.05162)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.76} stopOpacity={0} />
          <stop offset={0.95} stopOpacity={0.5} />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id={_id3}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-.63252 15.81305 -33.67857 -1.34714 4.02 5.7)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35C1F1" />
          <stop offset={0.11} stopColor="#34C1ED" />
          <stop offset={0.23} stopColor="#2FC2DF" />
          <stop offset={0.31} stopColor="#2BC3D2" />
          <stop offset={0.67} stopColor="#36C752" />
        </radialGradient>
        <radialGradient
          id={_id4}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(73.74 5.012 17.859)scale(7.60383 6.18343)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66EB6E" />
          <stop offset={1} stopColor="#66EB6E" stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id={_id5}
          x1={6.587}
          x2={20.518}
          y1={15.831}
          y2={15.831}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C59A4" />
          <stop offset={1} stopColor="#114A8B" />
        </linearGradient>
        <linearGradient
          id={_id6}
          x1={13.931}
          x2={5.23}
          y1={9.787}
          y2={19.265}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B9DE2" />
          <stop offset={0.16} stopColor="#1595DF" />
          <stop offset={0.67} stopColor="#0680D7" />
          <stop offset={1} stopColor="#0078D4" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(EdgeDark);
export { ForwardRef as EdgeDark };
